import { Box, styled } from '@mui/material';

export const StyledHeader = styled(Box)({
  background: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  padding: '24px 48px',
});
